import { GeneralAction } from '../../../../shared/infrastructure/store/actions/general_action';
import { Merchant } from '../../models/merchant.model';
import { MerchantCategory } from '../../models/merchant_category.model';
import { MerchantActionType as actions, MerchantActionType } from './action';

export type MerchantAction = {
    type: actions;
    payload?: any;
};
// TODO: Refactor old Action Types ->

export function getLiveMerchant(): MerchantAction {
    return { type: actions.GET_LIVE_MERCHANT };
}

export function getLiveMerchantSuccess(): MerchantAction {
    return { type: actions.GET_LIVE_MERCHANT_SUCCESS };
}

export function getLiveMerchantFailure(): MerchantAction {
    return { type: actions.GET_LIVE_MERCHANT_FAILURE };
}

// NEW ACTION CREATORS ->

export function creatingMerchantLiveAccount(): GeneralAction<MerchantActionType> {
    return { type: actions.CREATING_MERCHANT_LIVE_ACCOUNT };
}

export function creatingMerchantLiveAccountSuccess(merchant: Merchant): GeneralAction<MerchantActionType> {
    return { type: actions.CREATING_MERCHANT_LIVE_ACCOUNT_SUCCESS, payload: merchant };
}

export function creatingMerchantLiveAccountFailure(error: string): GeneralAction<MerchantActionType> {
    return { type: actions.CREATING_MERCHANT_LIVE_ACCOUNT_FAILURE, payload: error };
}

export function getLiveMerchantCategory(categories: MerchantCategory[]): GeneralAction<MerchantActionType> {
    return { type: actions.GET_LIVE_MERCHANT_CATEGORIES, payload: categories };
}

// TODO: Refactor old Action Types ->

export const getAllbusinessTypes = () => {
    return { type: actions.GET_ALL_BUSINESS_TYPES };
};

export const setAllbusinessTypes = data => {
    return { type: actions.SET_ALL_BUSINESS_TYPES, payload: data };
};

export const getMerchantCategory = () => {
    return { type: actions.GET_MERCHANTS_CATEGORY };
};

export const setMerchantCategory = data => {
    return { type: actions.SET_MERCHANTS_CATEGORY, payload: data };
};

export const updateMerchantDetails = data => {
    return { type: actions.UPDATE_MERCHANT_DETAILS, payload: data };
};

export const getMerchantDetails = data => {
    return { type: actions.GET_MERCHANT_DETAILS, payload: data };
};

export const setMerchantDetails = data => {
    return { type: actions.SET_MERCHANT_DETAILS, payload: data };
};

export const setMerchantProfile = data => {
    return { type: actions.SET_MERCHANT_PROFILE, payload: data };
};

export const getMerchantProfile = data => {
    return { type: actions.GET_MERCHANT_PROFILE, payload: data };
};

export const getKycStatus = data => {
    return { type: actions.GET_KYC_STATUS, payload: data };
};

export const setKycStatus = data => {
    return { type: actions.SET_KYC_STATUS, payload: data };
};

export const uploadMerchantsOnboading = data => {
    return { type: actions.UPLOAD_MERCHANTS_ONBOARDING, payload: data };
};

export const uploadKyc = data => {
    return { type: actions.UPLOAD_KYC, payload: data };
};

export const setKycTypes = data => {
    return { type: actions.SET_KYC_TYPES, payload: data };
};

export const getKycTypes = data => {
    return { type: actions.GET_KYC_TYPES, payload: data };
};

export const setOnboardingProfile = data => {
    return { type: actions.SET_ONBOARDING_PROFILE, payload: data };
};

export const getOnboardingProfile = data => {
    return { type: actions.GET_ONBOARDING_PROFILE, payload: data };
};

export const setAddNewBusiness = data => {
    return { type: actions.SET_ADD_NEW_BUSINESS, payload: data };
};

export const setAddNewBusinessError = data => {
    return { type: actions.SET_ADD_NEW_BUSINESS_ERROR, payload: data };
};

export const handleToggleUserMode = data => {
    return { type: actions.TOGGLE_USER_MODE, payload: data };
};

// Toggle app state -->

export const togglingAppMode = data => {
    return { type: actions.TOGGLING_APP_MODE, payload: data };
};

export const togglingAppModeSuccess = mode => {
    return { type: actions.TOGGLING_APP_MODE_SUCCESS, payload: mode };
};

export const togglingAppModeFailure = error => {
    return { type: actions.TOGGLING_APP_MODE_FAILURE, payload: error };
};

// Get Mode Type
export const getModeType = () => {
    return { type: actions.GET_MODE_TYPE };
};

export const getModeTypeSuccess = () => {
    return { type: actions.GET_MODE_TYPE_SUCCESS };
};

export const getModeTypeFailure = data => {
    return { type: actions.GET_MODE_TYPE_FAILURE, payload: data };
};

export const uploadMerchantLogo = data => {
    return { type: actions.UPLOAD_MERCHANT_LOGO, payload: data };
};
export const inviteEmployee = data => {
    return {
        type: actions.INVITE_EMPLOYEE,
        payload: data
    };
};

export const inviteEmployeeSuccess = data => {
    return {
        type: actions.INVITE_EMPLOYEE_SUCCESS,
        payload: data
    };
};

export const inviteEmployeeFailure = error => {
    return {
        type: actions.INVITE_EMPLOYEE_FAILURE,
        payload: error
    };
};

export const acceptInvite = data => {
    return {
        type: actions.ACCEPT_INVITE,
        payload: data
    };
};

export const acceptInviteSuccess = data => {
    return {
        type: actions.ACCEPT_INVITE_SUCCESS,
        payload: data
    };
};

export const acceptInviteFailure = error => {
    return {
        type: actions.ACCEPT_INVITE_FAILURE,
        payload: error
    };
};

export const resendInvite = data => {
    return {
        type: actions.RESEND_INVITE,
        payload: data
    };
};

export const resendInviteSuccess = data => {
    return {
        type: actions.RESEND_INVITE_SUCCESS,
        payload: data
    };
};

export const resendInviteFailure = error => {
    return {
        type: actions.RESEND_INVITE_FAILURE,
        payload: error
    };
};

export const suspendUser = data => {
    return {
        type: actions.SUSPEND_USER,
        payload: data
    };
};

export const suspendUserSuccess = data => {
    return {
        type: actions.SUSPEND_USER_SUCCESS,
        payload: data
    };
};

export const suspendUserFailure = error => {
    return {
        type: actions.SUSPEND_USER_FAILURE,
        payload: error
    };
};

export const revokeInvite = data => {
    return {
        type: actions.REVOKE_INVITE,
        payload: data
    };
};

export const revokeInviteSuccess = data => {
    return {
        type: actions.REVOKE_INVITE_SUCCESS,
        payload: data
    };
};

export const revokeInviteFailure = error => {
    return {
        type: actions.REVOKE_INVITE_FAILURE,
        payload: error
    };
};

export function getInvitation(): MerchantAction {
    return { type: actions.GET_INVITATION };
}

export function getInvitationSuccess(data: any): MerchantAction {
    return { type: actions.GET_INVITATION_SUCCESS, payload: data };
}

export function getInvitationFailure(error: string): MerchantAction {
    return { type: actions.GET_INVITATION_FAILURE, payload: error };
}

export const updateUserRole = data => {
    return {
        type: actions.UPDATE_USER_ROLE,
        payload: data
    };
};

export const updateUserRoleSuccess = data => {
    return {
        type: actions.UPDATE_USER_ROLE_SUCCESS,
        payload: data
    };
};

export const updateUserRoleFailure = error => {
    return {
        type: actions.UPDATE_USER_ROLE_FAILURE,
        payload: error
    };
};


export function twoFaSetup(): MerchantAction {
    return { type: actions.TWO_FA_SETUP };
}

export function twoFaSetupSuccess(data: any): MerchantAction {
    return { type: actions.TWO_FA_SETUP_SUCCESS, payload: data };
}

export function twoFaSetupFailure(error: string): MerchantAction {
    return { type: actions.TWO_FA_SETUP_FAILURE, payload: error };
}

export function twoFaEnable(code: string | number): MerchantAction {
    return { type: actions.TWO_FA_ENABLE, payload: { code } };
}

export function twoFaEnableSuccess(data: any): MerchantAction {
    return { type: actions.TWO_FA_ENABLE_SUCCESS, payload: data };
}

export function twoFaEnableFailure(error: string): MerchantAction {
    return { type: actions.TWO_FA_ENABLE_FAILURE, payload: error };
}

export function twoFaStatus(): MerchantAction {
    return { type: actions.TWO_FA_STATUS };
}

export function twoFaStatusSuccess(data: any): MerchantAction {
    return { type: actions.TWO_FA_STATUS_SUCCESS, payload: data };
}

export function twoFaStatusFailure(error: string): MerchantAction {
    return { type: actions.TWO_FA_STATUS_FAILURE, payload: error };
}

export function twoFaDisable(): MerchantAction {
    return { type: actions.TWO_FA_DISABLE };
}

export function twoFaDisableSuccess(data: any): MerchantAction {
    return { type: actions.TWO_FA_DISABLE_SUCCESS, payload: data };
}

export function twoFaDisableFailure(error: string): MerchantAction {
    return { type: actions.TWO_FA_DISABLE_FAILURE, payload: error };
}